module.exports = require("vscode-nls/lib/main");